import { css as muiCss } from '@mui/material/styles'

import type { CSSObject } from '../components/theme/themeTypes'

interface SerializedStyles {
  styles: string
}

/**
 * Material UI re-exports Emotion's `css`; its public CSSObject typing is wider
 * than Emotion's input type, so we narrow at this wrapper boundary.
 */
const css = muiCss as (value: CSSObject) => SerializedStyles

/**
 * Serializes a Kurama CSS object for APIs that require plain CSS text,
 * such as dynamically-created style elements.
 */
export const serializeCss = (styles: CSSObject): string => css(styles).styles
